import Swiper from 'swiper';
import $ from 'jquery';

export default class LatestNews {
  constructor() {
    this.$body = $('body');
    this.mSwiper = false;
    this.modifyDOM();
    this.addEvents();
  }

  modifyDOM() {
    this.initSlider();
  }

  addEvents() {
    $(window).on('resize', this.initSlider.bind(this));
  }

  initSlider() {
    if ((this.$body.hasClass('phone') || this.$body.hasClass('tablet')) && !this.mSwiper) {
      this.mSwiper = new Swiper('.latest-news-container', {
        loop: false,
        slidesPerView: 'auto',
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
          renderFraction: (currentClass, totalClass) => `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`,
        },
      });
    } else if (this.mSwiper) {
      this.mSwiper.destroy();
      this.mSwiper = false;
    }
  }
}
